import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import DraggableModal from 'components/DraggableModal';
import useModalPosition from 'components/DraggableModalPositioned/useModalPosition';
import styles from './style.module.less';
const DraggableModalPositioned = ({ children, title, onClose, storageKey, className, dialogSize, defaultFractionalPos, backdrop, }) => {
    const { bounds, modalRef, defaultPosition, onStart, onStop, } = useModalPosition(storageKey, dialogSize, defaultFractionalPos);
    return (_jsx(DraggableModal, { bounds: bounds, defaultPosition: defaultPosition, nodeRef: modalRef, onStart: onStart, onStop: onStop, onClose: onClose, title: title, className: clsx(className, styles.dialog), backdrop: backdrop, children: children }));
};
export default DraggableModalPositioned;
